// MYP Sciences strand names, so "A(i)" reads as something a teacher says.
const NAMES: Record<string, string> = {
  'A(i)': 'explain scientific knowledge',
  'A(ii)': 'apply knowledge to solve problems',
  'A(iii)': 'analyse and evaluate information',
  'B(i)': 'explain the problem or question',
  'B(ii)': 'formulate a testable hypothesis',
  'B(iii)': 'plan the variables and data',
  'B(iv)': 'design the investigation',
  'C(i)': 'present collected data',
  'C(ii)': 'interpret data and explain results',
  'C(iii)': 'evaluate the hypothesis',
  'C(iv)': 'evaluate the method',
  'C(v)': 'explain improvements',
  'D(i)': 'explain how science is applied',
  'D(ii)': 'discuss and evaluate implications',
  'D(iii)': 'use scientific language',
  'D(iv)': 'document sources',
};

/** "A(i)" -> "Strand A(i): explain scientific knowledge". */
export function strandName(label: string): string {
  const n = NAMES[label.replace(/\s+/g, '')];
  return n ? `Strand ${label}: ${n}` : `Strand ${label}`;
}
export function strandMeaning(label: string): string | undefined {
  return NAMES[label.replace(/\s+/g, '')];
}
